import classNames from 'classnames'
import { useFormContext } from 'react-hook-form'
import { connect, DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import { FileFormatBadge } from '@/Atomic/Molecules/FileFormatBadge'
import { CustomField } from '@/Atomic/Organisms/CustomField'
import { FormBody, FormFields, FormGroup } from '@/Atomic/Templates/Form'
import { getDataItemFormMap } from '@/utils/CRUD/read/dataItem/getDataItemMap'
import { isString } from '@/utils/isString'

interface DocumentDrawerFormBodyProps {
  dataItem: DataItem
  isEditing?: boolean
}

export const DocumentDrawerFormBody: React.FC<DocumentDrawerFormBodyProps> =
  connect(({ dataItem, isEditing }) => {
    const { getValues, watch } = useFormContext()
    const groups = getDataItemFormMap(dataItem, getValues, watch)

    return (
      <FormBody>
        {groups.map((group) => (
          <FormGroup key={group.name}>
            <StringText variant="title">{group.title}</StringText>
            <FormFields className={classNames({ display: !isEditing })}>
              {group.fields.map((field) => {
                const formatValue = isString(field.displayValue)
                  ? field.displayValue
                  : ''
                const isFormatField =
                  field.name === 'format' &&
                  !isEditing &&
                  formatValue.trim() !== ''

                if (isFormatField) {
                  return (
                    <div key={field.fieldKey} className="form-row-display">
                      <div className="label">
                        <StringText value={field.title || ''} />
                      </div>
                      <div className="value">
                        <FileFormatBadge format={formatValue} />
                      </div>
                    </div>
                  )
                }

                return (
                  <CustomField
                    key={field.fieldKey}
                    fieldMap={field}
                    isEditing={isEditing}
                    className="form-field"
                  />
                )
              })}
            </FormFields>
          </FormGroup>
        ))}
      </FormBody>
    )
  })
